import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { userActivityApi } from "./userActivity";
import { dashboardApi } from "./dashboard";

const withAuth = (headers) => {
  if (typeof document === "undefined") return headers;

  const tokenCookie = document.cookie
    .split(";")
    .map((cookie) => cookie.trim())
    .find((cookie) => cookie.startsWith("token="));

  if (tokenCookie) {
    headers.set("authorization", `Bearer ${tokenCookie.slice("token=".length)}`);
  }
  return headers;
};

export const requestStatusKey = (targetType, targetId) =>
  targetType && targetId ? `${targetType}:${String(targetId)}` : "";

export const repConnectionRequestsApi = createApi({
  reducerPath: "repConnectionRequestsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.NEXT_PUBLIC_BASE_URL}/rep-connection-requests/`,
    prepareHeaders: withAuth,
  }),
  tagTypes: ["RequestStatuses"],
  endpoints: (builder) => ({
    getRequestStatuses: builder.query({
      query: ({ targets = [] } = {}) => ({
        url: "status",
        method: "POST",
        body: { targets },
      }),
      providesTags: ["RequestStatuses"],
    }),
    submitProductRequest: builder.mutation({
      query: (body) => ({
        url: "",
        method: "POST",
        body,
      }),
      invalidatesTags: ["RequestStatuses"],
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(dashboardApi.util.invalidateTags(["LocalRequests"]));
        } catch {
          // Leave the current local feed intact when submission fails.
        }
      },
    }),
    submitSampleRequest: builder.mutation({
      query: ({ targetId, productId }) => ({
        url: `${process.env.NEXT_PUBLIC_BASE_URL}/product-requests/`,
        method: "POST",
        body: { productId: productId || targetId },
      }),
      invalidatesTags: ["RequestStatuses"],
      async onQueryStarted(_args, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(userActivityApi.util.invalidateTags(["MostRequested"]));
          dispatch(dashboardApi.util.invalidateTags(["LocalRequests"]));
        } catch {
          // The component displays the request error. Keep the cached ranking
          // untouched when submission fails.
        }
      },
    }),
  }),
});

export const {
  useGetRequestStatusesQuery,
  useSubmitProductRequestMutation,
  useSubmitSampleRequestMutation,
} = repConnectionRequestsApi;
